import VisitorPassTypes from './visitorPass.types';

// Create Visitor Pass Actions
export const createVisitorPassStart = (data: FormData) => ({
	type: VisitorPassTypes.CREATE_VISITOR_PASS_START,
	payload: data,
});

export const createVisitorPassSuccess = (data: any) => ({
	type: VisitorPassTypes.CREATE_VISITOR_PASS_SUCCESS,
	payload: data,
});

export const createVisitorPassFailure = (error: unknown) => ({
	type: VisitorPassTypes.CREATE_VISITOR_PASS_FAILURE,
	payload: error,
});

export const createVisitorPassResponseRestStart = () => ({
	type: VisitorPassTypes.CREATE_VISITOR_PASS_RESPONSE_REST_START,
});

// Get All Visitor Passes Actions
export const getAllVisitorPassesStart = (data: any) => ({
	type: VisitorPassTypes.GET_ALL_VISITOR_PASSES_START,
	payload: data,
});

export const getAllVisitorPassesSuccess = (data: any) => ({
	type: VisitorPassTypes.GET_ALL_VISITOR_PASSES_SUCCESS,
	payload: data,
});

export const getAllVisitorPassesFailure = (error: unknown) => ({
	type: VisitorPassTypes.GET_ALL_VISITOR_PASSES_FAILURE,
	payload: error,
});

export const getAllVisitorPassesResponseRestStart = () => ({
	type: VisitorPassTypes.GET_ALL_VISITOR_PASSES_RESPONSE_REST_START,
});

// Get Single Visitor Pass Actions
export const getVisitorPassStart = (data: any) => ({
	type: VisitorPassTypes.GET_VISITOR_PASS_START,
	payload: data,
});

export const getVisitorPassSuccess = (data: any) => ({
	type: VisitorPassTypes.GET_VISITOR_PASS_SUCCESS,
	payload: data,
});

export const getVisitorPassFailure = (error: unknown) => ({
	type: VisitorPassTypes.GET_VISITOR_PASS_FAILURE,
	payload: error,
});

export const getVisitorPassResponseRestStart = () => ({
	type: VisitorPassTypes.GET_VISITOR_PASS_RESPONSE_REST_START,
});

// Update Visitor Pass Actions
export const updateVisitorPassStart = (data: FormData) => ({
	type: VisitorPassTypes.UPDATE_VISITOR_PASS_START,
	payload: data,
});

export const updateVisitorPassSuccess = (data: any) => ({
	type: VisitorPassTypes.UPDATE_VISITOR_PASS_SUCCESS,
	payload: data,
});

export const updateVisitorPassFailure = (error: unknown) => ({
	type: VisitorPassTypes.UPDATE_VISITOR_PASS_FAILURE,
	payload: error,
});

export const updateVisitorPassResponseRestStart = () => ({
	type: VisitorPassTypes.UPDATE_VISITOR_PASS_RESPONSE_REST_START,
});

// Delete Visitor Pass Actions
export const deleteVisitorPassStart = (data: any) => ({
	type: VisitorPassTypes.DELETE_VISITOR_PASS_START,
	payload: data,
});

export const deleteVisitorPassSuccess = (data: any) => ({
	type: VisitorPassTypes.DELETE_VISITOR_PASS_SUCCESS,
	payload: data,
});

export const deleteVisitorPassFailure = (error: unknown) => ({
	type: VisitorPassTypes.DELETE_VISITOR_PASS_FAILURE,
	payload: error,
});

export const deleteVisitorPassResponseRestStart = () => ({
	type: VisitorPassTypes.DELETE_VISITOR_PASS_RESPONSE_REST_START,
});
